import { Inject } from '@odinjs/odin';

import { catchRenderException, Endpoint } from '@philips-emr/hpms-stipulator-commons';
import { TabWithContentAPI } from '@philips-emr/tws-components';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { HttpService } from '@philips-emr/tws-core/lib/services';

import { TipoOrigemAnexo } from '../anexo-tiss/anexo-tiss-controller';
import BaseController from '../BaseController';

@Controller({ fragment: 'historico-requisicao' })
export default class HistoricoRequisicaoaController extends BaseController {

  @Inject('tab-with-content-anexoTiss')
  private tabWithContentAnexosTiss: TabWithContentAPI;

  private showTabAnexosTiss: boolean = false;

  private init(): void {
    this.showTabAnexosTiss = false;
  }

  @OnMount({ target: 'panel-historico-requisicao' })
  public onMountLayoutHistoricoRequisicao(): void {
    this.init();

    const origem = TipoOrigemAnexo.ANEXOS_TISS_REQUISICOES;
    const { nrSeqContrato, nrSeqRequisicao } = this.historyService.getCurrentRouteParams();

    this.fetchGuiaShow(nrSeqContrato, nrSeqRequisicao, origem);
    this.context.set({ nrSequencia: nrSeqRequisicao, origem });
  }

  private fetchGuiaShow(nrSeqContrato: number | string, nrSequencia: number | string, origem: TipoOrigemAnexo): void {
    void HttpService.get<number>(Endpoint.GET.SHOW_ANEXO_TISS, { nrSeqContrato, nrSequencia, origem })
      .then(({ body }) => {
        this.showTabAnexosTiss = body ? body > 0 : false;
        catchRenderException(() => this.tabWithContentAnexosTiss.setVisible(this.showTabAnexosTiss));
      });
  }

}
